import CurrencyInput from 'react-currency-input-field';
import styled from 'styled-components';

export const NumberInputCell = styled(CurrencyInput)<{ $editMode: boolean; $hasLabel: boolean }>`
	transition: all 0.3s ease-in-out;
	border: none;
	text-overflow: ellipsis;
	overflow: hidden;
	white-space: nowrap;
	background-color: none;
	background: none;
	color: ${props => props.theme.palette.text.primary};
	font-size: ${props => (props.$editMode ? '0.95rem' : '1.05rem')};
	${props => (props.$editMode || !props.$hasLabel) && 'font-weight: 300; width: 100%; height: 100%;'};
	&:focus {
		outline: none;
		border: none;
	}
	&::placeholder {
		font-weight: 300;
		color: ${props => props.theme.palette.swiftfox.neutral['30-lightGrey']};
	}
	&:disabled {
		background-color: ${props => props.theme.palette.swiftfox.neutral['20-offWhite'] ?? 'none'};
		cursor: not-allowed;
	}
`;
